import type { Account, ProductType } from '@shared/products-types';
import { AccountType, CardType } from '@shared/products-types';

import type { ProductWithHelpers } from '../types/productHelpers';

export const getProductType = (product: ProductWithHelpers): ProductType | undefined => {
    // productType was already precomputed
    if (product.derivedType) {
        return product.derivedType;
    }

    if ((product as Account).type) {
        return (product as Account).type;
    }

    if (product.productType) {
        return product.productType;
    }

    if (product.card) {
        return product.card.type;
    }

    return undefined;
};

export const isProductType = (account: ProductWithHelpers, productType: string): boolean => {
    if (!account) {
        return false;
    }
    if (account.derivedType) {
        return account.derivedType === productType;
    }

    return getProductType(account) === productType;
};

/** Helpers for types */
export const isCurrentAccount = (account: ProductWithHelpers): boolean =>
    isProductType(account, AccountType.CURRENT);

export const isSavingAccount = (account: ProductWithHelpers): boolean =>
    isProductType(account, AccountType.SAVING);

export const isLoanAccount = (account: ProductWithHelpers): boolean =>
    isProductType(account, AccountType.LOAN);

export const isCreditCardAccount = (account: ProductWithHelpers): boolean =>
    isProductType(account, AccountType.CREDIT_CARD);

export const isCreditCard = (product: ProductWithHelpers) =>
    isProductType(product, CardType.CREDIT) || isProductType(product, CardType.VIRTUAL_CREDIT);
